import { ProductionClass } from '../production.class';
import * as Constants from '../../globals/constants';
import { ResourceService } from '../../services/resource.service';
import { PopulationService } from '../../services/population.service';
import { TechnologyService } from '../../services/technology.service';

/**
 * @internal
 * The isolateExtension allows the user to isolate current selection in the viewer.
 */
export class Farm extends ProductionClass {
  /**
   * @ignore
   */
  constructor(resourceService: ResourceService, populationService: PopulationService, technologyService: TechnologyService) {
    super(resourceService, populationService, technologyService);
    this.name = 'Farm';
    this.initBuilding('Farm', 'farm', Constants.SETTINGS.BUILDING_SETTINGS.FARM);
  }

  public produce(timePassed) {
    const resourceList = Object.entries(this.productionPerMinute);
    resourceList.forEach((resource) => {
      const prodPerMin = resource[1] * this.numberOfBuildings * this.reseachMultiplier * this.populationEfficienty;
      const costPerMin = this.populationService.getPopulation();
      const netProdPerMin = prodPerMin - costPerMin;
      this.produced[resource[0]] += ((netProdPerMin / 60000) * timePassed);
    });
  }

  public setResearchBonus() {
    const additiveMultiplier = [];
    const multiplicativeMultiplier = [];

    if (this.technologyService.state.stone_age) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.bronze_age) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.roman_age) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.iron_age) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.middle_age) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.colonial_age) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.industrial_age) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.progressive_era) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.contemporary_era) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.tomorrow) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.deep_space_age) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.dimensional_era) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }

    //---

    if (this.technologyService.state.cultivation) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.growing) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.agriculture) {
      multiplicativeMultiplier.push(.2);
    }

    if (this.technologyService.state.wheelbarrow) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.irrigation) {
      multiplicativeMultiplier.push(.15);
    }

    if (this.technologyService.state.oven) {
      multiplicativeMultiplier.push(.05);
    }

    if (this.technologyService.state.aqueducts) {
      multiplicativeMultiplier.push(.05);
    }

    if (this.technologyService.state.crop_rotation) {
      multiplicativeMultiplier.push(.05);
    }

    if (this.technologyService.state.fertilization) {
      multiplicativeMultiplier.push(.05);
    }

    if (this.technologyService.state.maritime_trading) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.plantation) {
      multiplicativeMultiplier.push(.05);
    }

    if (this.technologyService.state.factory) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.mass_production) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.mega_farms) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.arcology) {
      multiplicativeMultiplier.push(.2);
    }
    if (this.technologyService.state.matter_generation) {
      multiplicativeMultiplier.push(.15);
    }

    const amResult = additiveMultiplier.reduce((a, b) => a + b, 1);
    const mmResult = multiplicativeMultiplier.reduce((a, b) => a * (1 + b), 1);

    this.reseachMultiplier = 1 * amResult * mmResult;
  }

  public getBuildingImage() {
    return 'https://image.shutterstock.com/image-vector/rural-landscape-field-wheat-hand-260nw-1328421050.jpg'
    // if (this.technologyService.state.brick_house) {
    //   return 'https://i.pinimg.com/564x/75/b0/c0/75b0c082798d763add59f09fb17fddfa.jpg';
    // } else  if (this.technologyService.state.brick_house) {
    //     return 'https://i.pinimg.com/564x/75/b0/c0/75b0c082798d763add59f09fb17fddfa.jpg';
    //   } {
    //   return 'https://image.shutterstock.com/image-vector/rural-landscape-field-wheat-hand-260nw-1328421050.jpg'
    // }
  }

}
